import ProjectPropertyLookup, {SourceType} from "./project-property-lookup"
import ProjectSession from "../project-session"

export default class ProjectViewAppSettingsLookup extends ProjectPropertyLookup {

    constructor(projectId: ID) {
        super(projectId)
    }

    get(viewId:ID, forceInheritedOnly = false) {
        let res = null

        // 1. check if project has property and retrieve views
        res = this.getProjectViewsAppSettings(this.project, viewId)
        if (!!res) {
            this.sourceType = SourceType.CUSTOM
        }

        // 2. if views not found yet check parents
        const allParents = this.findAllParents()
        if ((!res || forceInheritedOnly) && allParents.length > 0) {
            _.some(allParents, project=>{
                res = this.getProjectViewsAppSettings(project, viewId)

                // if result found then inherited from current project
                if (!!res) {
                    this.sourceType = SourceType.INHERITED
                    this.sourceProjectId = project.id
                    return true // break iteration loop (_.some)
                }
            })

            /*// if no app settings found in any parent then take last (root) parent as inherit source
            if (!res) {
                res = {}
                this.sourceType = SourceType.INHERITED
                this.sourceProjectId = allParents[allParents.length - 1].id
            }*/
        }

        // 3. if app settings still not found return default app settings
        if (!res) {
            this.sourceType = SourceType.GENERIC
        }

        return res
    }

    getProjectViewsAppSettings(project:ProjectSession, viewId:ID) {
        return project.settings ? project.settings.viewsAppSettings.getConfig(viewId) : null
    }
}